var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Col',{attrs:{"span":"20"}},[_c('Table',{attrs:{"border":"border","row-key":"id","columns":_vm.columns,"data":_vm.data,"no-data-text":_vm.$t('main.tableNoDataText'),"no-filtered-data-text":_vm.$t('main.tableNoFilteredDataText')},scopedSlots:_vm._u([{key:"showName",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.$i18n.t(("routesMenu." + (row.name)))))])]}},{key:"read",fn:function(ref){
var row = ref.row;
return [_c('Checkbox',{attrs:{"value":row.read},on:{"on-change":function () {
var args = [], len = arguments.length;
while ( len-- ) args[ len ] = arguments[ len ];
 _vm.onChange.apply(void 0, [ row, 'read' ].concat( args ))}}})]}},{key:"write",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Checkbox',{attrs:{"value":row.write,"disabled":!_vm.$store.getters.isAdmin ? !_vm.parentChildrenItems[index].write : false},on:{"on-change":function () {
var args = [], len = arguments.length;
while ( len-- ) args[ len ] = arguments[ len ];
 _vm.onChange.apply(void 0, [ row, 'write' ].concat( args ))}}})]}},{key:"other",fn:function(ref){
var row = ref.row;
return _vm._l((Object.keys(row.other||{})),function(item,index){return _c('Row',{key:index},[_c('Checkbox',{attrs:{"value":row.other[item],"disabled":!_vm.$store.getters.isAdmin ? !_vm.parentChildrenItems[index].other[item] : false},on:{"on-change":function () {
var args = [], len = arguments.length;
while ( len-- ) args[ len ] = arguments[ len ];
 _vm.onChange.apply(void 0, [ row, ("other." + item) ].concat( args ))}}},[_vm._v(_vm._s(_vm.$i18n.t(("rolesmanage." + item))))])],1)})}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acad54ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rcmTableFormItems/TableCheckbox.vue
// module id = null
// module chunks = 